import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stage",
  "use": "icon-stage-usage",
  "viewBox": "0 0 1109 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1109 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-stage\"><path d=\"M51.882667 782.506667h188.842666V1024H51.882667V782.506667z m287.914666-247.552H533.333333v488.96H339.797333v-488.96z m288 94.208h191.914667v394.752H627.797333V629.162667z m287.914667-239.616H1109.333333v634.368h-193.621333V389.546667zM-0.085333 542.890667l448.512-418.474667 257.365333 256.682667 242.944-287.061334L860.672 0H1109.333333v244.224l-86.954666-90.965333-316.586667 389.034666-260.096-271.445333L62.378667 633.088l-62.464-90.197333z\" p-id=\"45054\" fill=\"#8a8a8a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/stage.svg
// module id = rwuO
// module chunks = 12